import { Star } from "lucide-react";

const StarRating = ({ rating }) => {
  const roundedRating = Math.round(rating || 0);
  return (
    <div className="flex flex-col items-center md:flex-row md:items-center md:justify-start mt-2 space-y-1 md:space-y-0 md:space-x-2">
      <div className="flex space-x-1">
        {[1, 2, 3, 4, 5].map((n) => (
          <Star
            key={n}
            size={20}
            className={`${
              n <= roundedRating
                ? "fill-yellow-400 stroke-yellow-400"
                : "stroke-gray-300"
            }`}
          />
        ))}
      </div>
      <span className="text-sm text-gray-600">
        {rating ? rating.toFixed(1) : "0.0"}/5
      </span>
    </div>
  );
};

export default StarRating;
